import styled from 'styled-components';

const TableContentStyle = styled.div`
	--otherInfoBlockWidth: 51%;
	--teamDescMTop: var(--sp2-5x);

	.otherInfoCont {
		display: flex;
		flex-wrap: wrap;
		margin-top: var(--portfolioItemMarg);
	}

	.otherInfo {
		display: flex;
		flex-wrap: wrap;
		flex: 0 0 var(--otherInfoBlockWidth);
		gap: var(--portfolioItemMarg);
	}

	.team-description {
		margin-top: var(--teamDescMTop);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) {
	}

	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) {
		--otherInfoBlockWidth: 53%;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
		--otherInfoBlockWidth: 51%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
		--teamDescMTop: var(--sp2x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
		--otherInfoBlockWidth: 48%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--otherInfoBlockWidth: 100%;

		.linkCont {
			margin-top: var(--sp3x);
		}
	}
`;

export default TableContentStyle;
